export default __webpack_public_path__ + "static/media/profile1.49c07f37.png";